import axios from "axios";
import { ENDPOINTS, TOKENS } from "../utilComponents/constants";
import AppError from "../utilComponents/ApiError";

const monthName = ["NaN", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

const BASE_URL = ENDPOINTS.DASHBOARD_BASE_URL;

export const fetchYearlyContactsOfLocation = async (locationId) => {

    const header = {
        "Authorization": `Bearer ${TOKENS.DASHBOARD_AUTH_TOKEN}`
    }

    try {
        const { data } = await axios.get(BASE_URL + `/dashboard/location/contact-count/yearly?locationId=${locationId}&year=2024`, { headers: header });
        return formatContactData(data.contacts);
    } catch (error) {
        console.log("ERROR: ", error);
        throw new AppError("Cannot fetch contact data");
    }
}

const formatContactData = (data) => {
    const contactCount = [];
    data.forEach(element => {
        const month = monthName[element.month];
        const count = element.contactCount;
        contactCount.push({
            "month": month,
            "count": count
        });
    });
    return contactCount;
}
